module.exports = __webpack_public_path__ + "static/media/donation_state.bd19e122.png";